import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { actionCreators } from "./redux/checkInSaga";
import LoadingAnimation from "../../components/loadingAnimation/loadingAnimation";
import SectionToggle from "../../components/sectionToggle/sectionToggle";
import YearOverYear from "./smartComponents/YearOverYear";
import DatePicker from "./smartComponents/DatePicker";
import CustomDateRanges from "./smartComponents/CustomDateRanges";
import MembershipTypeFilter from "./smartComponents/MembershipTypeFilter";
import { DataPoints } from "./smartComponents/DataPoints";
import { addSticky } from "../../utils/addSticky";
import { UpdateBtns } from "./smartComponents/UpdateBtns";
import { CheckInHeatmap } from "./smartComponents/HeatMapChart";
import KBLearnMore from "../../components/learnMore/KBLearnMore";
import NoData from "../../components/noData/noData";
import { ILEARN_URLS } from "../../constants/ilearnUrls";

export const checkInsModule = ({ numberOfMonths, ...restProps }) => {
  const dispatch = useDispatch();
  const isLoading = useSelector((state) => state.checkIns.isLoading);
  const updatesLoading = useSelector((state) => state.checkIns.updatesLoading);
  const membership_types = useSelector((state) => state.checkIns.selectedFilters.membership_types);
  const dataPoints = useSelector((state) => state.checkIns.dataPoints);
  const hasData =
    membership_types.length && dataPoints?.some((dataPoint) => dataPoint.total_checkins);

  const getData = () => {
    dispatch(
      actionCreators.fetchCurrentUser({
        currentUser: restProps,
        numberOfMonths: numberOfMonths
      })
    );
  };

  useEffect(() => {
    getData();
  }, []);

  useEffect(() => {
    if (!isLoading) {
      addSticky();
    }
  }, [isLoading]);

  return (
    <div className="check-in-module">
      <SectionToggle
        maxHeight="auto"
        autoHeight
        title="Check-Ins"
        customClass="class-check-in-heatmap withSticky"
        hideToggle
        isLoading={isLoading}
        learnMore={
          <KBLearnMore
            title="Check-Ins"
            description="This report shows successful and denied check-ins along with daily and weekly traffic patterns. These insights help you understand visit trends, anticipate staffing needs, and identify potential access issues that may require attention."
            kbUrl={ILEARN_URLS.checkIns.checkIns}
          />
        }
        content={
          <div>
            <div className="edit-selections-bar" id="sticky-select-bar">
              <div className="selection-bar-filters">
                <MembershipTypeFilter />
                <div className="select-box" style={{ width: "360px" }}>
                  <p className="offers-title">Date Range</p>
                  <CustomDateRanges />
                </div>
                <div className="date-select-box select-box multi">
                  <p className="offers-title">Date</p>
                  <DatePicker />
                </div>
              </div>

              <UpdateBtns reset={getData} />
            </div>
            {updatesLoading ? (
              <LoadingAnimation text="Updating heatmap..." />
            ) : hasData ? (
              <>
                <div className="content-wrapper">
                  <DataPoints />
                  <YearOverYear />
                </div>
                <CheckInHeatmap />
              </>
            ) : (
              <NoData />
            )}
          </div>
        }
      />
    </div>
  );
};

export default checkInsModule;
